<template>
  <v-container>
    <base-material-card
      icon="mdi-calendar"
      color="primary"
      inline
      class="px-5 py-3 my-12"
    >
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-bold">
          Eventos
        </div>
      </template>
      <div class="overflow-cards">
        <!-- <v-lazy
          :options="{
            threshold: 0.5
          }"
          min-height="200"
          transition="fade-transition"
          v-for="(item, index) in events"
          :key="index"
        >
          <v-card :color="item.color" light class="mb-4"
            ><v-card-title class="black--text">{{ item.name }}</v-card-title>
            <v-card-subtitle class="black--text">{{
              item.details
            }}</v-card-subtitle>
            <v-card-subtitle class="black--text">
              {{ item.start }} <br />
              {{ item.end }}</v-card-subtitle
            ></v-card
          >
        </v-lazy> -->
        <v-tabs
          v-model="tab"
          :color="$vuetify.theme.isDark ? 'white' : 'primary'"
          background-color="transparent"
          grow
        >
          <v-tab>
            Tasks to do
          </v-tab>
          <v-tab>
            History
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-container>
              <v-row v-if="groupedRealTaskList.length > 0">
                <work-day
                  v-for="days in groupedRealTaskList"
                  :key="days.date"
                  :date="days.date"
                  :events="days.events"
                  :history="true"
                  @doneTask="() => {}"
                  @deleteOneTask="() => {}"
                  @disableTask="() => {}"
                >
                </work-day>
              </v-row>
              <v-row v-else>
                <task :task="todayTaskSample"></task>
              </v-row>
            </v-container>
          </v-tab-item>
          <!-- ! Aquí debe ir el historial -->
          <v-tab-item>
            <v-container>
              <v-row v-if="historyList.length > 0">
                <work-day
                  v-for="days in groupedHistoryList"
                  :key="days.date"
                  :date="days.date"
                  :events="days.events"
                  :history="true"
                  @doneTask="() => {}"
                  @deleteOneTask="() => {}"
                  @disableTask="() => {}"
                >
                </work-day>
              </v-row>
              <v-row v-else>
                There are not tasks in history
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </base-material-card></v-container
  >
</template>

<script>
import lodash from "lodash";
export default {
  props: ["events", "selectedFilters", "search"],
  components: {
    WorkDay: () => import("../EquipmentProfile/Planner/WorkDay"),
    task: () => import("../EquipmentProfile/Planner/Task")
  },
  data() {
    return {
      isActive: false,
      tab: null,
      todayTaskSample: {
        id: "TODAY",
        taskDate: new Date(),
        showHeader: true
      }
    };
  },
  methods: {
    getSimpleDate(date) {
      const jsDate = new Date(date);
      const year = jsDate.getFullYear();
      const month =
        jsDate.getMonth() + 1 >= 10
          ? jsDate.getMonth() + 1
          : `0${jsDate.getMonth() + 1}`;
      const day =
        jsDate.getDate() >= 10 ? jsDate.getDate() : `0${jsDate.getDate()}`;

      return `${year}-${month}-${day}`;
    }
  },
  computed: {
    realTaskList() {
      if (this.events) {
        let realList = [];

        const todayTaskSample = {
          id: "TODAY",
          taskDate: this.getSimpleDate(new Date())
        };

        realList.push(todayTaskSample);

        //const today = new Date();
        this.events.forEach(task => {
          // Unique
          if (task.type === "unique" && !task.isDone) {
            realList.push({
              id: task.id,
              name: task.name,
              type: task.type,
              subtype: task.subtype,
              taskDate: task.start,
              description: task.description || task.details,
              lastTime: task.lastChange,
              changeTime: task.changeTime,
              alertTime: task.alertTime,
              disabledArray: task.disabledArray
            });
          }

          //Recurrent
          if (task.type === "recurrent" && !task.isDone) {

            let timeStart = new Date(task.start+'T00:00');
            let timeEnd = new Date(task.end+'T00:00');
            // time difference counting the first day
            let diffTime = (Math.abs(timeEnd - timeStart)/86400000)+1;
            let eventDuration = diffTime * 24 * 3600 * 1000;
            let finalTime = +timeStart + eventDuration;
            let dateToEvent = +timeStart;

            while (dateToEvent < finalTime) {
              // Si es evento recurrente con eventos eliminados

              const uniqueId = `${task.id}${dateToEvent}`;
              if (!task.disabledArray?.includes(uniqueId)) {
                const taskDate = this.getSimpleDate(dateToEvent);

                realList.push({
                  id: task.id,
                  uniqueId,
                  name: task.name,
                  type: task.type,
                  subtype: task.subtype,
                  taskDate,
                  description: task.description || task.details,
                  lastTime: task.lastChange,
                  changeTime: task.changeTime,
                  alertTime: task.alertTime,
                  disabledArray: task.disabledArray
                });
              }
              dateToEvent += task.changeTime * 1000;
            }
          }
        });
        return realList;
      }
      return [];
    },
    filteredRealTaskList() {
      if (this.realTaskList) {
        return this.realTaskList.filter(task => {
          const isToday = task.id === "TODAY";
          const isInFilters =
            this.selectedFilters.includes(task.type) &&
            this.selectedFilters.includes(task.subtype);

          const isInSearch =
            task?.name?.toLowerCase().includes(this.search.toLowerCase()) ||
            task?.subtype?.toLowerCase().includes(this.search.toLowerCase()) ||
            task?.type?.toLowerCase().includes(this.search.toLowerCase()) ||
            task?.description
              ?.toLowerCase()
              .includes(this.search.toLowerCase());

          return isToday || (isInSearch && isInFilters);
        });
      }
      return [];
    },
    groupedRealTaskList() {
      if (this.filteredRealTaskList) {
        const objectByDate = lodash.groupBy(
          this.filteredRealTaskList,
          "taskDate"
        );

        const arrayByDate = Object.entries(objectByDate).map(
          ([date, events]) => ({
            date,
            events
          })
        );

        arrayByDate.sort(function(dayA, dayB) {
          return dayA.date < dayB.date ? -1 : 1;
        });

        return arrayByDate;
      }
      return [];
    },
    historyList() {
      if (this.events) {
        let realList = [];

        this.events.forEach(task => {
          // Unique
          if (task.type === "unique" && task.isDone) {
            realList.push({
              id: task.id,
              name: task.name,
              type: task.type,
              subtype: task.subtype,
              taskDate: task.start,
              description: task.description || task.details,
              lastTime: task.lastChange,
              changeTime: task.changeTime,
              alertTime: task.alertTime,
              disabledArray: task.disabledArray
            });
          }
        });
        return realList;
      }
      return [];
    },
    filteredHistoryList() {
      return this.historyList.filter(task => {
        const isToday = task.id === "TODAY";
        const isInFilters =
          this.selectedFilters.includes(task.type) &&
          this.selectedFilters.includes(task.subtype);

        const isInSearch =
          task?.name?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.subtype?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.type?.toLowerCase().includes(this.search.toLowerCase()) ||
          task?.description?.toLowerCase().includes(this.search.toLowerCase());

        return isToday || (isInSearch && isInFilters);
      });
    },
    groupedHistoryList() {
      if (this.filteredHistoryList) {
        const objectByDate = lodash.groupBy(
          this.filteredHistoryList,
          "taskDate"
        );

        const arrayByDate = Object.entries(objectByDate).map(
          ([date, events]) => ({
            date,
            events
          })
        );

        arrayByDate.sort(function(dayA, dayB) {
          return dayA.date > dayB.date ? -1 : 1;
        });

        return arrayByDate;
      }
      return [];
    }
  }
};
</script>
